export const SET_SKILLS_EXECEPTIONS = 'SET_SKILLS_EXECEPTIONS'

export const SET_SKILLS_OPENING_HOURS = 'SET_SKILLS_OPENING_HOURS'
